import * as types from './mutation-types'
import {cacheManager} from "@/services/cacheManagerjs";


export const loadModules = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/suit/installed/modules', state.modules)
            .then((response) => {
                if(!response.fromState) commit(types.ADD_MODULES, response.data?.modules)
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}


